// extracted by mini-css-extract-plugin
module.exports = {"c7n-card-wider-padding":"c7n-card-wider-padding","c7n-card-body":"c7n-card-body"};